// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"8a831e139da1b3a2773d","115":"56345dbaee963bff44bb","116":"e14bb1d8b4624d81ff75","165":"068abd897941f30d2854"}[chunkId] + ".chunk.js";
};